import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus';

import { AnimateObserver } from './lib/animate-observer';
import { Mobile } from './lib/mobile';
import { Gallery } from './lib/gallery';

window.Mobile = Mobile;
window.Alpine = Alpine;

Alpine.plugin(collapse)
Alpine.plugin(focus);
Alpine.start()

const animate = new AnimateObserver();
animate.init();

const gallery = new Gallery();
gallery.init();

if ( document.querySelector( '.js-carousel' ) ) {
    import('./lib/carousel').then( module => {
        const carousel = new module.Carousel();
        carousel.init();
    } );
}

if ( document.querySelector( '.js-counter' ) ) {
    import('./lib/counter').then( module => {
        const counter = new module.Counter();
        counter.init();
    } );
}

// Load the non-critical JS when the user interacts with the page
const eventList = ['keydown', 'mousemove', 'wheel', 'touchmove', 'touchstart', 'touchend'];
const loadJS = () => {

    // Remove the event listeners
    eventList.forEach(event => {
        window.removeEventListener(event, loadJS);
    });

    // Get scripts with the data-src attribute
    const scripts = document.querySelectorAll('script[data-src]');

    // Loop over each script and set the src with data-src
    scripts.forEach(script => {
        script.src = script.dataset.src;
    });

}

// Add the event listeners
eventList.forEach(event => {
    document.addEventListener(event, loadJS, { passive: true });
});
